// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-11-07T15:17:52+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190344
//    Project:        617
//    Environment:    7626 - master
//    MD5:            dccd97b615daaaf18fa8fe92a0fcfb36
//    Signature:      eyJpdiI6IndQK0JjanhBM21YV2pRUXFGbCtkM2c9PSIsInZhbHVlIjoiNEJpVE9MaXBZc0FoUjhlamlwVm1jb1M0TjQ2ODBqVHpYOWc0bVIrZ1VMSTdvTVZJRWFWMzdHT1lDbkdiMDJ6T2owaW5WVUFcL0tLTFwvVm1QcjlWMjVcL1dSTTA3b1lCSlwvN0t3NlJ5RndlV1BwU2MxRFdjdld3OHRJRElpZ3FwdFY5SkY0XC93YnpHS3FRR1wvNjdzMHFsZ0JvRm1uM1NLZ3ludDhmRE1TdENQa0hlTEpiYnJPMmdSRnZWKzFwVlhZN1ZWaXFrOFZybnl0ZFF0MHNiNzV0NmYyTk9rMDJQVWhFTGF0Rk9CTkk3ZWZqT3QwWkxmNElvNVFYcDc5allNWEI1WnZ2UHNqTzdZNVBwekN4Q0VWcVI3RHFwaTY5ckE0bFJsV0dWN0FNZWlKWXAxMUF4WFNWUmpMR01OK0VnbFhXNkZTRm5qYkZ5WUxMZ2VjaWxlNnZBWllYZGdVZ0pnK1ZXSllvVWl5MTZmWmJxdmFzeFpHM2JGcnI4TE0yUWs3K1RrRUdjXC9IV1B4eDV2WmJsZTI2M1czUlRDUWY4S2tibzljZEZJS1wvdFwvK1pTcz0iLCJtYWMiOiJlYzIzZGY1OWVkZWI4MGIyZDMyMmU1NzUxNGM2MGZkNWE1NzhlYTlhNzFjMWMxNGY5YTc3YmRjNjgxZmMwMTY1In0=
$(document).ready(function () {
    let x=8;
    let to_show = 8;
    let size_li = $(".accordion-item.active").length;
    if (size_li > to_show) {
      $('.load-more-module').removeClass('hide')
    }
    let percentage = (x / size_li)*100;
    $('.fill').css('width', percentage+'%');
    $('.accordion-item.active:lt('+x+')').removeClass('hide');
    $('.accordion-item.active:lt('+x+')').addClass('active');
    $('#viewed-count').html(x)
    $('.loadMore').click(function () {
        x= (x+to_show <= size_li) ? x+to_show : size_li;
        $('#viewed-count').html(x)
        percentage = (x / size_li)*100;
        $('.fill').css('width', percentage+'%');
        $('.accordion-item.active:lt('+x+')').removeClass('hide');
        $('.accordion-item.active:lt('+x+')').addClass('active');
        if(x == size_li){
            $('.fill').css('width', '100%');
            $('.loadMore').hide();
        }
    });
  });
